// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe474237","455":"febe870e","977":"b06bdfda"}[chunkId] + ".chunk.js";
};